import illustrationWork from 'site/assets/svgs/work.svg'
import RouterLink from 'ui/components/RouterLink'

export const featureGroups1 = [
	{
		title: 'Tehokkaat työkalut isännöintiin',
		illustration: illustrationWork,
		features: [
			{
				title: 'Pidetään asukkaista huolta',
				icon: 'accessibility_new',
				description:
					'Viilu-palvelu on taloyhtiöiden asioiden hoitamiseen kehitetty palvelu. Palvelu on suunniteltu olemaan niin helppokäyttöinen työkalu asukkaille, osakkaille ja hallituksille kuin nykypäivänä osataan odottaakin.',
			},
			{
				title: 'Kasvetaan ja kehitytään yhdessä',
				icon: 'work',
				description:
					'Viilu on suunniteltu myös isännöintitoimistot mielessä pitäen. Olemme jatkuvassa vuorovaikutuksessa isännöintiasiakkaidemme kanssa, koska vain he tietävät mitä isännöitsijän arki on ja miten sitä helpotettaisiin.',
			},
			{
				title: 'Ota yhteyttä',
				icon: 'call',
				featureAction: (
					<RouterLink
						href={'/support'}
						style={{
							color: '#FFFFFF',
							fontWeight: 'bold',
						}}
					>
						{'Ota yhteyttä >'}
					</RouterLink>
				),
				description:
					'Ota siis yhteyttä niin voidaan yhdessä keskustella mitä juuri teidän toimistonne tarvitsee ottaakseen sen seuraavan askeleen.',
			},
		],
	},
]

export const featureGroups2 = [
	{
		title: 'Täydentää muita työkalujanne',
		illustration:
			'https://firebasestorage.googleapis.com/v0/b/taloyhtio-app.appspot.com/o/static%2Fintegrations.svg?alt=media&token=1f3245ba-36af-41eb-b6c9-64fcde3b8066',
		illustrationStyles: {
			position: 'absolute',
			left: '25vw',
			borderRadius: 8,
			background: 'white',
			width: '35vw',
			maxWidth: 454,
			height: 'auto',
		},
		features: [
			{
				title: 'Modulaarinen rakenne',
				icon: 'add_box',
				description:
					'Viilu-palvelu on suunniteltu modulaariseksi. Tämä tarkoittaa sitä, että voit halutessasi käyttä jokaista tarjoamaamme nippeliä tai vain tarvitsemiasi osia. Näin vältytään esim. päällekäisyyksiltä muiden palveluntarjoajien kanssa.',
			},
			{
				title: 'Taloushallinnosta',
				icon: 'account_balance',
				description:
					'Tärkeää on tiedostaa se, että me Viilulla emme tee taloushallinto-ohjelmistoja. Me keskitymme viestintään, päätöksentekoon ja hallintoon. Me kuitenkin integroidumme alan johtavien taloushallito-ohjelmistojen kanssa. Tämä tarkoittaa sitä, että sinä voit valita juuri sinulle parhaan taloushallintojärjestelmän.',
			},
			{
				title: 'Integraatiot ja rajapinnat',
				icon: 'hub',
				description:
					'Integroidumme useimpiin alalla vakiintuneisiin isännöintijärjestelmiin ja kiinteistöjärjestelmiin.',
			},
		],
	},
]

export const featureGroups3 = [
	{
		title: 'Viilu helpottaa isännöitsijän arkea',
		features: [
			{
				title: 'Vuoropuhelua isännöinnin kanssa',
				icon: 'groups',
				description:
					'Asiakkainamme on pieniä yhden hengen toimistoja sekä suuria satojen henkilöiden konserneja. Pidämme ensiarvoisen tärkeänä isännöitsijöiden ja isännöintiyrittäjien kuuntelua ja heidän kanssaan keskustelua, koska he tietävät mikä isännöintiprosessissa voisi toimia paremmin.',
			},
			{
				title: 'Prosessiajattelu ja datan hyödyntäminen',
				icon: 'linear_scale',
				description:
					'Kehitämme kaikkia palveluitamme prosessiajattelua hyödyntäen. Tämä tarkoittaa sitä, että katsotaan asioita hieman isompina kokonaisuuksina yksittäisten tehtävien sijaan. Tästä hyvä esimerkki on kokouspalvelumme, joka säästää isännöitsijän aikaa huimasti. Aikasäästöt saavutetaan fiksuilla prosesseilla, automatiikalla ja olemassa olevaa dataa hyödyntäen.',
			},
			{
				title: 'Ota yhteyttä',
				icon: 'call',
				featureAction: (
					<RouterLink
						href={'/support'}
						style={{
							color: '#FFFFFF',
							fontWeight: 'bold',
						}}
					>
						{'Ota yhteyttä >'}
					</RouterLink>
				),
				description:
					'Kerro sinäkin meille mikä voisi olla teidän prosessissanne paremmin!',
			},
		],
	},
]
